var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35483 5.16852C2.86193 4.65228 2.88544 3.83854 3.40733 3.35099C3.92922 2.86343 4.75186 2.88668 5.24476 3.40292L12 10.4781L18.7552 3.40292C19.2481 2.88668 20.0708 2.86343 20.5927 3.35099C21.1146 3.83854 21.1381 4.65228 20.6452 5.16852L14.1226 12L20.6452 18.8315C21.1381 19.3477 21.1146 20.1615 20.5927 20.649C20.0708 21.1366 19.2481 21.1133 18.7552 20.5971L12 13.5219L5.24476 20.5971C4.75186 21.1133 3.92922 21.1366 3.40733 20.649C2.88544 20.1615 2.86193 19.3477 3.35483 18.8315L9.87743 12L3.35483 5.16852Z",
    fill: "#62646E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.31b436c822e4287c545d9b99a346feff.svg";
export { ForwardRef as ReactComponent };